export const clientes = [
  "/clientes/1.png",
  "/clientes/2.png",
  "/clientes/3.png",
  "/clientes/4.png",
  "/clientes/5.png",
  "/clientes/1.png",
  "/clientes/2.png",
  "/clientes/3.png",
  "/clientes/4.png",
  "/clientes/5.png",
  "/clientes/1.png",
  "/clientes/2.png",
  "/clientes/3.png",
  "/clientes/4.png",
  "/clientes/5.png",
  "/clientes/1.png",
  "/clientes/2.png",
  "/clientes/3.png",
  "/clientes/4.png",
  "/clientes/5.png",
];
